import { render, staticRenderFns } from "./TicketForm.vue?vue&type=template&id=07768416&scoped=true&"
import script from "./TicketForm.vue?vue&type=script&lang=js&"
export * from "./TicketForm.vue?vue&type=script&lang=js&"
import style0 from "./TicketForm.vue?vue&type=style&index=0&id=07768416&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07768416",
  null
  
)

export default component.exports